module.exports = require('./helpers/bundle-url').getBundleURL('8qGB4') + "logo.c51670a8.svg";